module.exports = __webpack_public_path__ + "img/section3Card3Icon3.6264873e.png";